var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"table_store":"autoinformer/stats/details/table"},scopedSlots:_vm._u([{key:"state",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("autoinformer.stats.state." + (item.state))))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }